import { ClubWithRatings } from './../../entities/club-with-ratings';
import { Guid } from './../../entities/guid';
import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { ClubGoal, FiscalYear, ClubGoalCollection } from '../../entities/';
import { HttpClient } from './http-client.service';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';
import { Settings } from '../../settings';

@Injectable()
export class ClubRatingService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly clubRatingBaseUrl:string = `${Settings.apiUrl}/v1/ClubRatings`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  public getFinalizedForDistrict(orgNodeId:string, fiscalYearId:number):Promise<boolean>{
    let clubRatingUrl:string = `${ClubRatingService.clubRatingBaseUrl}/RCC.GetFinalizedForDistrict(OrgNodeId=${orgNodeId},FiscalYearId=${fiscalYearId})/`;
    
    return this.http.get(clubRatingUrl)
      .toPromise()
      .then(response => {
        let isFinalized = response.json().value;
        return isFinalized;
      });
  }

  public updateFinalizedForDistrict(orgNodeId:string, fiscalYearId:number, isFinalized:boolean): Promise<number> {

    let clubRatingUrl: string = `${Settings.apiUrl}/v1/ClubRatings/RCC.UpdateFinalizedForDistrict(OrgNodeId=${orgNodeId},FiscalYearId=${fiscalYearId},IsFinalized=${isFinalized})/`;

    return this.http.put(clubRatingUrl, JSON.stringify(''), this.options)
      .toPromise()
      .then(response => {
        return response.json().value;
      });
  }

  // MCM-1093 Get the list of clubs with Ratings for selected district
  public GetDistrictClubsWithRatings(orgNodeId: string,fiscalYearId:number):Promise<ClubWithRatings[]>{
    let clubsWithRatingsBaseUrl = `${ClubRatingService.clubRatingBaseUrl}/RCC.GetDistrictClubsWithRatings(OrgNodeId=${orgNodeId},FiscalYearId=${fiscalYearId})/`;

    return this.http.get(clubsWithRatingsBaseUrl)
      .toPromise()
      .then((response) => { return response.json().value; });
  }

  // MCM-1093 Clear selected club's rating
  public ClearClubRatings(clubRatingId: string): Promise<ClubWithRatings> {
    let clubRatingUrl = `${ClubRatingService.clubRatingBaseUrl}/RCC.ClearClubRatings(ClubRatingId=${clubRatingId})/`;
    
    if(clubRatingId && clubRatingId != Guid.EMPTY){
      return this.http.put(clubRatingUrl, JSON.stringify(''), this.options)
      .toPromise()
      .then(response => {return response.json().value;
      });
    }   
  } 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/club-rating.service.ts